import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Couching_services_section.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { routeList } from "../../utils/routeList";
import { Modal, Button } from "react-bootstrap";
import {
  myBookingSvg,
  MyCoachingSessionSvg,
  requestCoachingSvg, requestCoachingserviceSvg,
} from "../../utils/SvgComps";
import { useNavigate } from "react-router-dom";
import CoachingServicesModal from "../NewDesign/Halifax/Coaching/Listing/CoachingServicesModal";
import CoachingListing from "../NewDesign/Halifax/Coaching/Listing/CoachingListing";
import MyCoachingServices from "./MyCoachingServices";
import ViewCoaches from "../../pages/CoachingRequestForm/View_Coaches/ViewCoaches";
import IndustriesListing from "../NewDesign/Halifax/Coaching/Listing/IndustriesListing";
import CoachingServicesListing from "../NewDesign/Halifax/Coaching/Listing/CoachingServicesListing";
import MyCoachingServicesListing from "../NewDesign/Halifax/Coaching/Listing/MyCoachingServicesListing";
const Coaching_Services_Section = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [showModal, setshowModal] = useState(false);
  const handleClose = () => {
    setshowModal(false);
  };
  const [key, setKey] = useState("tab1");
  function clearFormData() {
    localStorage.removeItem("selectedIndustry");
    localStorage.removeItem("mentoringPeriod");
    localStorage.removeItem("directReports");
    localStorage.removeItem("preferredMode");
    localStorage.removeItem("selectedSkillSet");
    localStorage.removeItem("selectedExperience");
    localStorage.removeItem("selectedSkills");
    localStorage.removeItem("selectedInterests");
    localStorage.removeItem("phoneNumber");
  }

  const userDetails = useSelector((state) => state.user.userBroker);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  useEffect(() => {
    console.log("tab", tab);
    if (tab === "1") {
      setKey("tab1");
    } else if (tab === "2") {
      setKey("tab2");
    } else if (tab === "3") {
      setKey("tab3");
    } else if (tab === "4") {
      setKey("tab4");
    } else if (tab === "5") {
      setKey("tab5");
    }
  }, [tab]);
  useEffect(() => { }, [userDetails]);
  const [firstBoxText, setFirstBoxText] = useState("");
  const [secondBoxText, setSecondBoxText] = useState("");
  const [firstBoxUrl, setFirstBoxUrl] = useState("");
  const [secondBoxUrl, setSecondBoxUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // const handleRequestCoaching = () => {
  //   setFirstBoxText(t("Pick your coach"));
  //   setFirstBoxUrl("/view-coaches");
  //   setSecondBoxText(t("Pick your pre-packaged coaching service"));
  //   setSecondBoxUrl("/coaching-services")
  //   setshowModal(true)
  // };

  const handleMyBookings = () => {
    setFirstBoxText("My Coaches");
    setFirstBoxUrl("/view-coaches?mycoaches=true");
    setSecondBoxText("My Coaching Services");
    setSecondBoxUrl("/coaching-services?my-coaching-services=true");
    setshowModal(true);
  };

  return (
    <>
      {key === "tab1" ? (
        <div className="coachingbox">
          <div className="row">
            <div className=" mb-botm col-md-12 col-lg-6 col-xl-6 partnercard mb-4">
              <div className="couching-frm-box">
                <div className="cach-dcac h-100">
                  <div className="d-flex gap-2 h-100">
                    <div className="svg-bx">{requestCoachingSvg()}</div>
                    <div className="textsec d-flex flex-column justify-content-betweeen h-100">
                      <h4>{t("Request personal coaching")}</h4>

                      <p>{t("RequestCoachingPara")}</p>
                      <Link
                        to="/learn/coachingservices?tab=2"
                        className="w-100 d-block mt-auto"
                      // onClick={() => {
                      //   clearFormData();
                      // }}
                      >
                        <button
                          className="startcourse-btn"
                        // onClick={handleRequestCoaching}
                        >
                          {t("Request personal coaching")}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                          >
                            <path
                              d="M19.25 14.9996C19.25 14.5854 18.9142 14.2496 18.5 14.2496C18.0858 14.2496 17.75 14.5854 17.75 14.9996H19.25ZM17.75 20.9996C17.75 21.4138 18.0858 21.7496 18.5 21.7496C18.9142 21.7496 19.25 21.4138 19.25 20.9996H17.75ZM5.61478 7.51308C5.20545 7.44969 4.82223 7.73013 4.75884 8.13947C4.69544 8.5488 4.97588 8.93202 5.38522 8.99541L5.61478 7.51308ZM9.22949 9.98699C9.61583 10.1364 10.0501 9.94432 10.1995 9.55799C10.3489 9.17166 10.1568 8.73736 9.77051 8.58797L9.22949 9.98699ZM5.61478 11.5131C5.20545 11.4497 4.82223 11.7301 4.75884 12.1395C4.69544 12.5488 4.97588 12.932 5.38522 12.9954L5.61478 11.5131ZM7.31653 13.3852C7.71815 13.4865 8.12588 13.2431 8.22721 12.8414C8.32854 12.4398 8.0851 12.0321 7.68347 11.9307L7.31653 13.3852ZM13.25 6.05298C13.25 5.63876 12.9142 5.30298 12.5 5.30298C12.0858 5.30298 11.75 5.63876 11.75 6.05298H13.25ZM12.5 20.9996V21.7496C12.9142 21.7496 13.25 21.4138 13.25 20.9996H12.5ZM21.75 13.9996C21.75 14.4138 22.0858 14.7496 22.5 14.7496C22.9142 14.7496 23.25 14.4138 23.25 13.9996H21.75ZM21.5 18.7496C21.9142 18.7496 22.25 18.4138 22.25 17.9996C22.25 17.5854 21.9142 17.2496 21.5 17.2496V18.7496ZM15.5 17.2496C15.0858 17.2496 14.75 17.5854 14.75 17.9996C14.75 18.4138 15.0858 18.7496 15.5 18.7496V17.2496ZM17.75 14.9996V20.9996H19.25V14.9996H17.75ZM5.38522 8.99541C6.61399 9.18571 7.97085 9.50027 9.22949 9.98699L9.77051 8.58797C8.38471 8.05207 6.91756 7.71484 5.61478 7.51308L5.38522 8.99541ZM5.38522 12.9954C6.00446 13.0913 6.65813 13.2191 7.31653 13.3852L7.68347 11.9307C6.97447 11.7519 6.27452 11.6152 5.61478 11.5131L5.38522 12.9954ZM11.75 6.05298V20.9996H13.25V6.05298H11.75ZM4.41012 3.75614C6.58646 4.00206 9.41678 4.65809 11.3864 6.03827L12.2472 4.80983C9.96948 3.21376 6.83895 2.52105 4.57854 2.26562L4.41012 3.75614ZM4.41012 19.1172C6.58646 19.3631 9.41678 20.0191 11.3864 21.3993L12.2472 20.1709C9.96948 18.5748 6.83895 17.8821 4.57854 17.6267L4.41012 19.1172ZM1.75 4.93479V16.1996H3.25V4.93479H1.75ZM4.57854 17.6267C3.82877 17.5419 3.25 16.9186 3.25 16.1996H1.75C1.75 17.7428 2.96408 18.9538 4.41012 19.1172L4.57854 17.6267ZM4.57854 2.26562C2.96654 2.08347 1.75 3.4289 1.75 4.93479H3.25C3.25 4.17837 3.82631 3.69017 4.41012 3.75614L4.57854 2.26562ZM20.4215 2.26562C18.1611 2.52105 15.0305 3.21376 12.7528 4.80983L13.6136 6.03827C15.5832 4.65809 18.4135 4.00206 20.5899 3.75614L20.4215 2.26562ZM21.75 4.93479V13.9996H23.25V4.93479H21.75ZM20.5899 3.75614C21.1737 3.69017 21.75 4.17837 21.75 4.93479H23.25C23.25 3.4289 22.0335 2.08347 20.4215 2.26562L20.5899 3.75614ZM11.3864 6.03827C12.053 6.50532 12.947 6.50532 13.6136 6.03827L12.7528 4.80983C12.603 4.91479 12.397 4.91479 12.2472 4.80983L11.3864 6.03827ZM11.3864 21.3993C11.7209 21.6337 12.1118 21.7496 12.5 21.7496V20.2496C12.4091 20.2496 12.3209 20.2225 12.2472 20.1709L11.3864 21.3993ZM21.5 17.2496H15.5V18.7496H21.5V17.2496Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className=" mb-botm col-md-12 col-lg-6 col-xl-6 partnercard mb-4">
              <div className="couching-frm-box">
                <div className="cach-dcac h-100">
                  <div className="d-flex gap-2 h-100">
                    <div className="svg-bx fdfff">{requestCoachingserviceSvg()}</div>
                    <div className="textsec d-flex flex-column justify-content-betweeen h-100">
                      <h4>{t("Coaching workshops")}</h4>

                      <p>{t("accessYourPersonalizedListPara")}</p>
                      <Link to="/learn/coachingservices?tab=4" className="w-100 d-block mt-auto">
                        <button className="startcourse-btn">
                          {t("Coaching workshops")}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_3782_78967)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.08738 5.44329V2.23513C7.08738 2.13332 7.12781 2.0358 7.19957 1.96407C7.27158 1.89207 7.3691 1.85164 7.47091 1.85164H23.3586C23.4604 1.85164 23.558 1.89207 23.6297 1.96407C23.7017 2.0358 23.7421 2.13332 23.7421 2.23513V14.3645C23.7421 14.4663 23.7017 14.5638 23.6297 14.6356C23.558 14.7076 23.4604 14.748 23.3586 14.748H15.4308C15.2216 14.748 15.0519 14.9177 15.0519 15.1269C15.0519 15.3361 15.2216 15.5058 15.4308 15.5058H23.3586C23.6613 15.5058 23.9516 15.3856 24.1658 15.1716C24.3798 14.9574 24.5 14.6671 24.5 14.3645V2.23513C24.5 1.93249 24.3798 1.64221 24.1658 1.42798C23.9516 1.21398 23.6613 1.09375 23.3586 1.09375C20.4872 1.09375 10.3423 1.09375 7.47091 1.09375C7.16827 1.09375 6.87775 1.21402 6.66376 1.42798C6.44976 1.64221 6.32953 1.93249 6.32953 2.23513V5.44329C6.32953 5.65245 6.4993 5.82222 6.70846 5.82222C6.91762 5.82222 7.08738 5.65249 7.08738 5.44329Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M15.237 17.1436V22.5279C15.237 22.7371 15.407 22.9068 15.6159 22.9068C15.8251 22.9068 15.9949 22.7371 15.9949 22.5279V17.1436C15.9949 16.9344 15.8251 16.7646 15.6159 16.7646C15.407 16.7646 15.237 16.9344 15.237 17.1436Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M24.121 12.5342H19.8632C19.3731 12.5342 18.976 12.9313 18.976 13.4214V15.1267C18.976 15.3359 19.1457 15.5056 19.3549 15.5056C19.5641 15.5056 19.7338 15.3358 19.7338 15.1267V13.4214C19.7338 13.3499 19.7917 13.2921 19.8632 13.2921H24.121C24.3302 13.2921 24.4999 13.1223 24.4999 12.9131C24.4999 12.704 24.3302 12.5342 24.121 12.5342Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.34765 4.40727H14.5802C14.7891 4.40727 14.9591 4.2375 14.9591 4.02834C14.9591 3.81914 14.7891 3.64941 14.5802 3.64941H9.34765C9.13849 3.64941 8.96872 3.81918 8.96872 4.02834C8.96868 4.2375 9.13845 4.40727 9.34765 4.40727Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.34765 6.36528H21.8845C22.0937 6.36528 22.2634 6.19551 22.2634 5.98635C22.2634 5.77743 22.0936 5.60742 21.8845 5.60742H9.34765C9.13849 5.60742 8.96872 5.77743 8.96872 5.98635C8.96868 6.19551 9.13845 6.36528 9.34765 6.36528Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.641 8.32426H14.1138C14.323 8.32426 14.4927 8.15449 14.4927 7.94533C14.4927 7.73613 14.3229 7.56641 14.1138 7.56641H11.641C11.4321 7.56641 11.2621 7.73617 11.2621 7.94533C11.2621 8.15449 11.4321 8.32426 11.641 8.32426Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.713 10.9991H21.6243C21.8335 10.9991 22.0032 10.8293 22.0032 10.6201C22.0032 10.4112 21.8334 10.2412 21.6243 10.2412H17.713C17.5038 10.2412 17.3341 10.4112 17.3341 10.6201C17.3341 10.8293 17.5039 10.9991 17.713 10.9991Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18.6491 8.32426H21.8239C22.0331 8.32426 22.2028 8.15449 22.2028 7.94533C22.2028 7.73613 22.0331 7.56641 21.8239 7.56641H18.6491C18.4401 7.56641 18.2701 7.73617 18.2701 7.94533C18.2701 8.15449 18.4401 8.32426 18.6491 8.32426Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M6.54471 6.25879C4.6209 6.25879 3.05914 7.82055 3.05914 9.74435C3.05914 11.6682 4.6209 13.2299 6.54471 13.2299C8.46823 13.2299 10.0303 11.6682 10.0303 9.74435C10.0303 7.82055 8.46827 6.25879 6.54471 6.25879ZM6.54471 7.01668C8.05015 7.01668 9.27237 8.23891 9.27237 9.74435C9.27237 11.2498 8.05015 12.472 6.54471 12.472C5.03926 12.472 3.81704 11.2498 3.81704 9.74435C3.81704 8.23891 5.0393 7.01668 6.54471 7.01668Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.8807 12.9167L11.4632 14.2766C11.3917 14.3451 11.2967 14.3832 11.1977 14.3832H4.63659C2.95963 14.3832 1.52745 15.5936 1.2478 17.2473C0.995679 18.7373 0.693274 20.526 0.515936 21.5746C0.4601 21.9058 0.552831 22.2448 0.769559 22.5015C0.986564 22.7582 1.30538 22.9062 1.64139 22.9062H8.66454C9.29511 22.9062 9.8062 22.3951 9.8062 21.7649V18.1788C9.8062 18.1444 9.81959 18.1115 9.84385 18.0873C9.86834 18.063 9.90119 18.0494 9.93555 18.0494H11.6191C12.3937 18.0494 13.1382 17.7501 13.697 17.214C14.2 16.7314 14.8659 16.0928 15.4187 15.5622C15.7696 15.2257 15.9722 14.7637 15.9823 14.2776C15.9924 13.7966 15.8128 13.331 15.4829 12.9814C15.4796 12.9778 15.4654 12.9632 15.4619 12.9596C15.1264 12.6156 14.6687 12.4167 14.1876 12.4066C13.7015 12.3968 13.2316 12.5799 12.8807 12.9167ZM11.9879 14.8233C12.2982 14.5257 12.883 13.9646 13.4054 13.4634C13.6111 13.2661 13.8869 13.1584 14.1719 13.1645C14.4541 13.1703 14.7224 13.2868 14.9192 13.4886C14.9212 13.4909 14.9295 13.4995 14.9316 13.5017C15.1251 13.7066 15.2304 13.9797 15.2246 14.2616C15.2188 14.5468 15.0998 14.8179 14.8939 15.0153C14.3411 15.5458 13.6752 16.1844 13.1722 16.667C12.7546 17.0677 12.1981 17.2915 11.619 17.2915C11.0544 17.2915 10.3847 17.2915 9.93547 17.2915C9.70004 17.2915 9.47443 17.385 9.30795 17.5514C9.14171 17.7177 9.04823 17.9435 9.04823 18.1787V21.7648C9.04799 21.9765 8.87644 22.1483 8.66474 22.1483C8.6645 22.1483 1.64135 22.1483 1.64135 22.1483C1.5284 22.1483 1.42129 22.0985 1.34853 22.0124C1.27554 21.926 1.24447 21.8121 1.26313 21.7009L1.99499 17.3736C2.21303 16.0847 3.3294 15.1411 4.63651 15.1411H11.1976C11.4922 15.1411 11.7752 15.0271 11.9879 14.8233Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M3.90318 22.5902L4.56585 18.6707C4.60072 18.4645 4.46174 18.2687 4.25536 18.2339C4.04921 18.199 3.8534 18.3382 3.81857 18.5444L3.1559 22.4639C3.12103 22.6701 3.25997 22.8659 3.46639 22.9007C3.67254 22.9356 3.86834 22.7964 3.90318 22.5902Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M3.92038 20.5948H6.20013C6.27162 20.5948 6.32947 20.6527 6.32947 20.7242V22.5275C6.32947 22.7366 6.49924 22.9064 6.7084 22.9064C6.9176 22.9064 7.08733 22.7366 7.08733 22.5275V20.7242C7.08733 20.234 6.68993 19.8369 6.20009 19.8369C5.39595 19.8369 3.92034 19.8369 3.92034 19.8369C3.71118 19.8369 3.54141 20.0067 3.54141 20.2158C3.54141 20.425 3.71118 20.5948 3.92038 20.5948Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14.9409 12.9658L16.5105 8.05995C16.5741 7.86061 16.4643 7.64741 16.2649 7.58349C16.0659 7.51985 15.8524 7.62974 15.7885 7.82907L14.2191 12.7349C14.1554 12.934 14.2653 13.1474 14.4644 13.2114C14.6638 13.275 14.8772 13.1648 14.9409 12.9658Z"
                                fill="#415385"
                                stroke="#415385"
                                stroke-width="0.3"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_3782_78967">
                                <rect
                                  width="24"
                                  height="24"
                                  fill="white"
                                  transform="translate(0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className=" mb-botm col-md-12 col-lg-6 col-xl-6 partnercard mb-4">
              <div className="couching-frm-box">
                <div className="cach-dcac h-100">
                  <div className="d-flex gap-2 h-100">
                    <div className="svg-bx">{MyCoachingSessionSvg()}</div>

                    <div className="textsec d-flex flex-column justify-content-betweeen h-100">
                      <h4>{t("myCoachingSessions")}</h4>
                      <p>{t("myCoachingSessionsPara")}</p>
                      <Link to="/learn/coachingservices?tab=3" className="w-100 d-block mt-auto">
                        <button className="startcourse-btn">
                          {t("viewSessions")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="20"
                            viewBox="0 0 18 20"
                            fill="none"
                          >
                            <path
                              d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V1C3 0.716667 3.09583 0.479167 3.2875 0.2875C3.47917 0.0958333 3.71667 0 4 0C4.28333 0 4.52083 0.0958333 4.7125 0.2875C4.90417 0.479167 5 0.716667 5 1V2H13V1C13 0.716667 13.0958 0.479167 13.2875 0.2875C13.4792 0.0958333 13.7167 0 14 0C14.2833 0 14.5208 0.0958333 14.7125 0.2875C14.9042 0.479167 15 0.716667 15 1V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z"
                              fill="#415385"
                            />
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className=" mb-botm col-md-12 col-lg-6 col-xl-6 partnercard mb-4">
              <div className="couching-frm-box">
                <div className="cach-dcac h-100">
                  <div className="d-flex gap-2 h-100">
                    <div className="svg-bx">{myBookingSvg()}</div>

                    <div className="textsec d-flex flex-column justify-content-betweeen h-100">
                      <h4>{t("myBookings")}</h4>
                      <p>{t("accessYourPersonalizedListPara")}</p>
                      <Link to={routeList.MY_COACHING_BOOKINGS} className="w-100 d-block mt-auto">
                        <button className="startcourse-btn">
                          {t("myBookings")}{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="20"
                            viewBox="0 0 18 20"
                            fill="none"
                          >
                            <path
                              d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V1C3 0.716667 3.09583 0.479167 3.2875 0.2875C3.47917 0.0958333 3.71667 0 4 0C4.28333 0 4.52083 0.0958333 4.7125 0.2875C4.90417 0.479167 5 0.716667 5 1V2H13V1C13 0.716667 13.0958 0.479167 13.2875 0.2875C13.4792 0.0958333 13.7167 0 14 0C14.2833 0 14.5208 0.0958333 14.7125 0.2875C14.9042 0.479167 15 0.716667 15 1V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z"
                              fill="#415385"
                            />
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>


        </div>
      ) : key === "tab2" ? (
        <ViewCoaches />
      ) : key === "tab3" ? (
        <MyCoachingServices />
      ) : key === "tab4" ? (
        <IndustriesListing />
      ) : key === "tab5" ? (
        <MyCoachingServicesListing />
      ) : (
        ""
      )}

      <CoachingServicesModal
        showModal={showModal}
        handleClose={handleClose}
        firstBoxText={firstBoxText}
        secondBoxText={secondBoxText}
        firstBoxUrl={firstBoxUrl}
        secondBoxUrl={secondBoxUrl}
      />
    </>
  );
};

export default Coaching_Services_Section;
